@if (!loading) {
  @if (navItems?.length) {
    <button mat-button [matMenuTriggerFor]="orgMenu.childMenu">
      <div class="button-body-wrapper">
        <mat-icon class="prefix">warehouse</mat-icon>
        <div class="display-infos">
          <h1 class="main-title" id="appMainTitle" [matTooltip]="warehouse.name" matTooltipPosition="above">
            {{ warehouse.name }}
          </h1>
          <h4 id="appMainTitle2" class="sub-title">{{ warehouse?.organization.name }}</h4>
        </div>
        <mat-icon class="suffix">chevron_right</mat-icon>
      </div>
    </button>
  } @else {
    <button mat-button>
      <div class="button-body-wrapper">
        <mat-icon class="prefix">warehouse</mat-icon>
        <div class="display-infos">
          <h1 id="appMainTitle" class="main-title" [matTooltip]="warehouse?.name" matTooltipPosition="above">{{ warehouse?.name }}</h1>
          <h4 id="appMainTitle2" class="sub-title">{{ warehouse?.organization.name }}</h4>
        </div>
      </div>
    </button>
  }
  <app-menu-item #orgMenu [parent]="menuItem" [items]="navItems" (navItemClicked)="navigateTo($event)"></app-menu-item>
} @else {
  <div class="selector-loader">
    <app-loader [formField]="true" [message]="'watson.nav.switching' | translate" class="dark"></app-loader>
  </div>
}
